import axios from './axios';

export interface BarcodeProfile {
  name: string;
  prefix: string;
  paperWidth: number;
  paperHeight: number;
  cols: number;
  rows: number;
  gapX: number;
  gapY: number;
  marginTop: number;
  marginBottom: number;
  marginLeft: number;
  marginRight: number;
  lastSerial?: string;
  sheetCount?: number;
  paperSizeName?: string;
}

async function getLastSerial(prefix: string): Promise<string | undefined> {
  const res = await axios.get(`/barcode/${prefix}/last-serial`);
  return res.data.data?.lastSerialNumber;
}

async function saveLastSerial(prefix: string, lastSerialNumber: number): Promise<void> {
  await axios.patch(`/barcode/${prefix}/last-serial`, { lastSerialNumber });
}

async function getProfiles(prefix: string): Promise<BarcodeProfile[]> {
  const res = await axios.get(`/barcode/${prefix}/profile`);
  return res.data.data?.profiles as BarcodeProfile[];
}

async function saveProfile(profile: BarcodeProfile): Promise<BarcodeProfile[]> {
  const res = await axios.patch(`/barcode/${profile.prefix}/profile`, profile);
  return res.data.data?.profiles as BarcodeProfile[];
}

export const barcodeService = { getLastSerial, saveLastSerial, getProfiles, saveProfile };
